
import React from 'react';
import styled from 'styled-components';
import Button from './Button';
import ButtonDeposit from './Deposit/ButtonDeposit';
import { Form } from 'antd';
import shopSelectors from 'services/shop/selectors';
type Props = {
  onBack?: () => void;
  onNext?: () => void;
  onBook?: () => void;
  onDeposit?: () => void;
  onBookNew?: () => void;
  onOk?: () => void;
  onClose?: () => void;
};
const ActionsStep = ({ onBack, onBook, onDeposit, onNext, onOk, onClose, onBookNew }: Props) => {
  const settingDeposit = shopSelectors.data.settingDepositBooking();
  return (
    <Container>
      {onBack && <Button cancel onClick={onBack}>BACK</Button>}
      {onClose && <Button cancel onClick={onClose}>CLOSE</Button>}
      {onNext && <Button onClick={onNext}>NEXT</Button>}
      {
        settingDeposit?.active ? (
          <Form.Item name={'customers'} noStyle >{onDeposit && <ButtonDeposit onClick={onDeposit} />}</Form.Item>
        ) : (
          onBook && <Button onClick={onBook}>BOOK</Button>
        )
      }
      {onOk && <Button onClick={onOk}>OK</Button>}
      {onBookNew && <Button onClick={onBookNew}>BOOK ANOTHER APPOINTMENT</Button>}
    </Container>
  );
};

export default ActionsStep;
const Container = styled.div`
position: sticky;
bottom: 0;
z-index: 99;
display: flex;
padding: 12px 16px 0 16px;
padding-bottom: 12px;
align-items: center;
gap: 12px;
background: #fff;
box-shadow: 0 -2px 4px 0 rgba(0, 0, 0, 0.15);
button {
  flex: 1;
}
`;
